import React, { useRef, useState, MouseEvent, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUnixTime } from 'date-fns';


import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grid from '@mui/material/Grid';
import Grow from '@mui/material/Grow';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';


import {LockOutlined} from '@mui/icons-material';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { isFalsy } from 'utility-types';

import {Language as LanguageIcon, TranslateOutlined as TranslateOutlinedIcon,  } from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useTranslation  } from 'react-i18next';
import { useSnackbar } from 'notistack';

import ReCAPTCHA from 'react-google-recaptcha';

import { ThreeDots } from 'react-loader-spinner';
import { IUserCredential, IUserSession } from 'features/identity/models/User';

import useIdentityUserService from 'features/identity/services/User';

import useApplicationSetupService from 'features/setup/services/ApplicationSetup';
import useProductService from 'features/setup/services/Product';


import useAxios from 'library/axios';
import { useRecoilState } from 'recoil';
import { useMutation } from 'react-query';
import { useLocalStorage } from 'react-use';
import { currentUserSessionAtom, hubConnectionIdAtom, colorsAtom, lastUnixTimeStampAtom, allProductsAtom } from 'library/store';
import md5 from 'md5';
import { IResult } from 'library/interface';

import __axios from "axios";

import { globalConfig } from 'config';
import useVisibilityToggle from 'library/useVisibilityToggle';
import { blue } from '@mui/material/colors';
import { IAppTheme, defaultAppTheme } from 'themes/commonStyles';
import { random } from 'lodash';

 

function Copyright(props: any) {
    return (
      <Typography variant="body2" color="text.secondary" align="center" {...props}>
        {'Copyright © '}
        <Link color="inherit" href="https://www.univsoft.com/shine">
          
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
    );
  }

export const Login = () => {

  const axios = useAxios();

  const { t, i18n } = useTranslation();
  const { enqueueSnackbar } = useSnackbar(); 
  const navigate = useNavigate();

  const { isPasswordStrong } = useIdentityUserService();

  const { getWebsiteAuthImages } = useApplicationSetupService();
  

  const { show: showPassword, toggleVisibility: togglePasswordVisibility } = useVisibilityToggle();

  const [hubConnectionId, setHubConnectionId] = useRecoilState(hubConnectionIdAtom);
  
  const [ storeCustomerID, setStoreCustomerID ,  removeStoreCustomerID]  = useLocalStorage('CustomerID');
  const [ storeLanguage, setStoreLanguage ,  removeStoreLanguage]  = useLocalStorage<string>('Language');
  
  const [ storeLogin, setStoreLogin, removeStoreLogin  ] = useLocalStorage<string>('Login');

  const [ storeTenant, setStoreTenant, removeStoreTenant] = useLocalStorage<string>('Tenant');

  const [ storeAppThemeBackground, setStoreAppThemeBackground, removeStoreAppThemeBackground] = useLocalStorage<string>(defaultAppTheme.background);
  const [ storeAppThemePrimary, setStoreAppThemePrimary, removeStoreAppThemePrimary] = useLocalStorage<string>(defaultAppTheme.primary);
  const [ storeAppThemeSecondary, setStoreAppThemeSecondary, removeStoreAppThemeSecondary] = useLocalStorage<string>(defaultAppTheme.secondary);

  const { register, getValues, setValue ,formState: { errors } } = useForm<IUserCredential>(
    {defaultValues: {language: isFalsy(storeLanguage)?'fr':storeLanguage, userName: isFalsy(storeLogin)?'': storeLogin, password: ''}});

  const [currentUserSession, setCurrentUserSession] = useRecoilState(currentUserSessionAtom);

  const [allProducts, setAllProducts] = useRecoilState(allProductsAtom);

  const [Colors, setColors] = useRecoilState(colorsAtom);
  
  // const setCurrentUser = useUserStore(state => state.setCurrentUser);

  const anchorRefLanguageButton = useRef(null);
  const [openLanguageMenu, setOpenLanguageMenu] = useState(false);

  const inputLogin = useRef();
  const inputPassword = useRef();

  const [isVerified, setIsVerified] = useState<boolean>(false);

  const [bgIndex, setBgIndex] = useState<number>(1);
  //const {setCurrentUser} = useUserStore();

  const createVisitor = async (visiorInfo: any) => 
    await (await axios.post('/api/identity/token/add-visit', {...visiorInfo, appName: 'app' })).data;

  const postCredential = async (md5Credential: IUserCredential) => 
    await (await axios.post('/api/identity/token/get-token', {...md5Credential })).data;

  const getWorkspace = async (w: string) : Promise<{websiteApplicationApiToken: string}>  => {
    const {data} = (await axios.get(`/api/identity/token/get-workspace?w=${w}`));
    return await data;
  }
    


  const {isLoading, isError, isSuccess ,error,mutate} = useMutation< IResult<IUserSession>,Error,IUserCredential>(postCredential,
     {
       retry:2,
       onSuccess: async (data: IResult<IUserSession>) => {
        try {
          
          if(!data.succeeded) {
            enqueueSnackbar( data.messages.join( '\n'), { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
            return;
          }
          
          if(!data.data.isAuthenticated) {
            enqueueSnackbar( t('Invalid user credential'), { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 }); 
            return;
          }

          var shouldResetPassword = data.data.shouldResetPassword;

          if(!data.data.shouldResetPassword && data.data.displayPasswordExpirationWarning) {
            enqueueSnackbar( t('Your password is going to expire in few days, you have to change it.'), { variant: 'warning',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 4500 });
          }

          if(data.data.isPasswordComplexityAllowed && !isPasswordStrong(getValues().password) ) {
            enqueueSnackbar( t('You must change your password because the complexity is not respeted'), { variant: 'error',
                anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });
            //data.data.shouldResetPassword
            shouldResetPassword = true;
          }            
          
          setCurrentUserSession({...data.data, shouldResetPassword });
          
          if(!isFalsy(data.data.applicationSetup.applicationTheme)){
            setColors(data.data.applicationSetup.applicationTheme);
            setStoreAppThemeBackground(data.data.applicationSetup.applicationTheme.background);
            setStoreAppThemePrimary(data.data.applicationSetup.applicationTheme.primary);
            setStoreAppThemeSecondary(data.data.applicationSetup.applicationTheme.secondary);
          }            
         
          if(shouldResetPassword)
            navigate('/passwordChange');  
          else
            navigate('/home');  

          
          

        } catch {

        }
       }
    });

  
    const handleChangeLanguage = (
      event: React.MouseEvent<HTMLElement>,
      newLanguage: string,
    ) => {
      //setLanguage(newLanguage);
      i18n.changeLanguage(newLanguage);
      setOpenLanguageMenu(false);
      setStoreLanguage(newLanguage);
      setValue('language', newLanguage);
    };

    const onClickLanguageMenu = () => {
      setOpenLanguageMenu(true);  
    };
  
    const menuLanguageItemClick = (lg: string) => (event: any) =>{
      i18n.changeLanguage(lg);
      setOpenLanguageMenu(false);
      setStoreLanguage(lg);
      setValue('language', lg);

      //localStorage.setItem('lastLanguage', lg);
    }
  
    const onChangeReCAPTCHA = (value: any) => {
      
      setIsVerified(isFalsy(value));
      
    }

    const closeLanguageMenu = () => {
      setOpenLanguageMenu(false);
    };


  const postLogin = async (event: MouseEvent<HTMLButtonElement>) => {
    
    event.preventDefault();
    
    const  {userName, password, language } = getValues();

    const {hostname, host} = window.location;

    const tempTenant = window.location.search.replace('?','');
    //const tenantAlias =  host.split('.')[0];

    const tenantAlias = isFalsy(tempTenant) ? (storeTenant || '') : tempTenant;
      

    if(tenantAlias === '') {
      enqueueSnackbar( t('The url is invalid, you have to add ?xxxx at the of url'), { variant: 'error',
          anchorOrigin : { horizontal: 'center', vertical: 'top' }, autoHideDuration : 2000 });

      const tenant = 'xxxx';
      //window.location.replace(`${host}?${tenant}`);
      return;
    }

    setStoreTenant(tenantAlias);
    // if( externalCustomerID && externalCustomerID <= 0) {
    //   alert('invalid banque ...');
    //   return;
    // }

    //setStoreCustomerID(externalCustomerID);
        

     mutate( { userName, password: md5(password), language, tenantAlias, hubConnectionId } );

    //console.log(data);
    //event.preventDefault();
    //const data = new FormData(event.currentTarget);
    // eslint-disable-next-line no-console
    // console.log({
    //   email: data.get('email'),
    //   password: data.get('password'),
    // });
  };

  useEffect( () => {
    const _ = async () => {

      setColors({...Colors, 
          background: storeAppThemeBackground || defaultAppTheme.background, 
          primary: storeAppThemePrimary || defaultAppTheme.primary, 
          secondary: storeAppThemeSecondary|| defaultAppTheme.secondary});
    }

    _();
  }, [] );


  const [currentWebsiteImages, setCurrentWebsiteImages] = useState<{image_Url: string}[]>([]);
  const [websiteImageUrl, setWebsiteImageUrl] = useState<string>('');
  useEffect( () => {
    const _ = async () => {

      const tempTenant = window.location.search.replace('?','');
      const tenantAlias = isFalsy(tempTenant) ? (storeTenant || '') : tempTenant;
      if(isFalsy(tenantAlias)) return;

      const workspace = await getWorkspace(tenantAlias);
     
      const websiteImages = await getWebsiteAuthImages(workspace.websiteApplicationApiToken);
      setCurrentWebsiteImages(websiteImages);
    }

    _();
  }, [] );

  const refBgIndex = useRef<number>(0);
  const refWebsiteImage = useRef<string>('');
  const [imageFolder, setImageFolder] = useState<string>('sales');
  const COUNT_BG_IMAGES = 5;
  useEffect(() => {
    const interval = setInterval(() => {
      
      const rand = Math.random();
           
      if(currentWebsiteImages && currentWebsiteImages.length>0){
        
        refBgIndex.current = Math.floor(rand*currentWebsiteImages.length);
        refWebsiteImage.current = `${globalConfig.get().websiteApiUrl}/download/${currentWebsiteImages[refBgIndex.current].image_Url}`;
        setWebsiteImageUrl(`${globalConfig.get().websiteApiUrl}/download/${currentWebsiteImages[refBgIndex.current].image_Url}`);
        setBgIndex( Math.floor(rand*currentWebsiteImages.length) );
      }        
      else { 
        refBgIndex.current = Math.floor(rand*COUNT_BG_IMAGES ) + 1;
        setBgIndex( Math.floor(rand*COUNT_BG_IMAGES ) + 1 );
      } 
        
    }, 30000);
    return () => clearInterval(interval);
  }, [currentWebsiteImages]);

  useEffect(() => {
    const fetchIPAddress = async () => {
      try {
        const response = await __axios.get('https://api.ipify.org?format=json');
        const {ip} = response.data;

        const visitorInfo = await fetchCountry(ip);
        await createVisitor(visitorInfo);

      } catch (error) {
        console.log(error);
      }
    };

    const fetchCountry = async (ip: string) : Promise<any> => {
      try {
        const response = await __axios.get(`https://ipapi.co/${ip}/json`);
        const countryData = response.data;

        //console.log(countryData);
        return countryData;
        //setCountry(countryData);
      } catch (error) {
        console.error('Error fetching country:', error);
      }
    };

    
    const createVisitorInfo = async () => {
      try {
        const response = await __axios.get(`http://ip-api.com/json/`);
        const visitorInfo = response.data;

        await createVisitor(visitorInfo);
        
      } catch (error) {
        console.error('Error fetching country:', error);
      }
    };

    const {hostname, host} = window.location;
    const tempTenant = window.location.search.replace('?','');
    const tenantAlias = isFalsy(tempTenant) ? (storeTenant || '') : tempTenant;

    const app =  host.split('.')[0];

    setImageFolder(app);

    if(isFalsy(tenantAlias))
      fetchIPAddress();
    
  }, []);

  return (    
    
    <Grid container component="main" key={`${currentWebsiteImages.length} ${websiteImageUrl} ${refBgIndex.current} ${imageFolder}`}
                    sx={{ height: '100vh',                     
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: (currentWebsiteImages && currentWebsiteImages.length>0 && !isFalsy(refWebsiteImage.current))?
                                            `${refWebsiteImage.current}`
                                          :`url(/images/${imageFolder}/${refBgIndex.current}.jpg)`,
                    backgroundColor: (t) => t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
                    backgroundSize: 'cover',
                    backgroundPosition: 'center', }}
        >
        <Box
          component="img" key={` ${currentWebsiteImages.length} ${websiteImageUrl} ${refBgIndex.current} ${imageFolder}`}
          src={(currentWebsiteImages && currentWebsiteImages.length>0 && !isFalsy(refWebsiteImage.current))?
            `${refWebsiteImage.current}`
           :`url(/images/${imageFolder}/${refBgIndex.current}.jpg)`}
          alt="background"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -1,
          }}
        />    
        <Grid item xs={1} sm={4} md={4} lg={5}></Grid>
        
        <Grid item container xs={10} sm={5} md={4} lg={3} justifyContent="center" alignItems="center" >
          
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', 
              alignContent:'center', width: '100%',
              background: 'white', opacity: 0.9, borderRadius: 10 }} >
            <Box sx={{ mt: 1, width: '100%', px: 2  }} > 
              <ToggleButtonGroup size="small"
                color="primary"
                value={getValues().language}
                exclusive
                onChange={handleChangeLanguage}
                aria-label="Small sizes"
              >
                <ToggleButton value="fr">Francais</ToggleButton>
                <ToggleButton value="en">English</ToggleButton>                
              </ToggleButtonGroup>
            </Box>
            <Avatar sx={{ m: 1, bgcolor: 'primary.main' }}>
              <LockOutlined />
            </Avatar>
            <Typography component="h1" variant="h5">
              {t('Signin')}
            </Typography>
            <Box sx={{ mt: 1, width: '100%'}}>
              <TextField sx={{width:'calc(100% - 8px)'}} required  id="email" label={t('Login')} {...register('userName')} defaultValue={ (storeLogin || '') as string}
                inputRef={inputLogin} inputProps={ { autoComplete: 'new-password', style: {textTransform: 'none'} } } 
                InputProps={{
                  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                    if(event.key === 'Enter' && inputPassword.current)
                      (inputPassword.current as HTMLInputElement).focus();
                  },
                }}
              />
            </Box>
            <Box sx={{ mt: 1, width: '100%'}}>
              <TextField sx={{width:'calc(100% - 8px)'}} required label={t('Password')} {...register('password')}
                type={showPassword ? 'text' : 'password'}
                id="password" autoComplete="current-password" inputRef={inputPassword}
                inputProps={ { style: {textTransform: 'none'} } }
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),

                  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => {
                    if(event.key === 'Enter') {
                      const btnPostLogin = document.getElementById(`btnPostLogin`);
                      if(btnPostLogin !== null)
                        btnPostLogin?.click();                        
                    }
                      //postLogin( new MouseEvent<HTMLButtonElement,MouseEvent>('button') );
                  },
                }} />
             </Box> 
             <Box sx={{ mt: 1, width: '100%', p:2}}> 
              <Button type="submit" fullWidth variant="contained" 
                      sx={{ mt: 3, mb: 2, pl: 2, pr: 2 }}  id="btnPostLogin"
                      onClick={postLogin} disabled={globalConfig.get().useReCAPTCHA && !isVerified}
                  >
                {isLoading ? <ThreeDots
                        color='#00BFFF'
                        height={'100%'}
                        //width={100}
                        //timeout={3000} //3 secs
                      /> : t('Signin')}
              </Button>
              
              { globalConfig.get().useReCAPTCHA &&
                    <ReCAPTCHA 
                      //sitekey="6Lc04M0jAAAAAOSY1VBblg7pW96C_HR_7rfAChx6"
                      sitekey={globalConfig.get().siteKeyReCAPTCHA}
                      onChange={onChangeReCAPTCHA}
                      size="normal"
                    />
              }
              </Box>
              <Box sx={{ mt: 1, width: '100%'}}> 
              <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                   
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {isError? "Error" : ""}
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={1} sm={3} md={4} lg={4}></Grid>
      </Grid>
  )
}
